export default {
  searchUserPlaceholder: 'Namn eller e-post',
  searchUsersMatching: '0 användare matchade din sökning. Kolla så du har stavat rätt, kanske kan du lägga till ett efternamn? | 1 användare matchade din sökning. | {userCount} användare matchade din sökning.',
  selectAll: 'Markera hela jaktlaget',
  deselectAll: 'Avmarkera hela jaktlaget'
}
